import { lazy } from 'react';

export const DashboardPageLazy = lazy(() => import('./dashboard-page'));
